module.exports = __webpack_public_path__ + "img/GXKL10.png";